import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Inject,
    Input,
    Output
} from '@angular/core';
import { ENVIRONMENT, Environment } from '@classifieds-sell/environment';
import { CancelDraftService } from 'libs/datalayer/src';

@Component({
    selector: 'tm-start-over',
    templateUrl: './start-over-modal.component.html',
    styleUrls: ['./start-over-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StartOverModalComponent {
    @Input() public categoryId: number;
    @Input() public subCategory: string;
    @Output() closeModal: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private _cancelDraftService: CancelDraftService,
        @Inject(ENVIRONMENT) private env: Environment) { }

    public onClose(): void {
        this.closeModal.emit();
    }

    public confirmCancel(): void {
        this._cancelDraftService.cancelDraft(this.categoryId, this.subCategory).subscribe();
        let url = `${this.env.frontendUrl}/${this.categoryId}`;

        if (this.subCategory){
            url = `${url}/${this.subCategory}`;
        }

        window.location.href = url;
    }
}
